import z from "zod";

export const zSidLabel = z.object({
  id: z.string(),
  label: z.string(),
});

export type ZSidLabel = z.infer<typeof zSidLabel>;
